import React from 'react';
import FormField from '../FormField';

export default function EducacaoSaude() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual da educação, do ensino superior, da qualificação profissional e da saúde no município.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="educacao_saude_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual da educação e da saúde no município, considerando educação infantil, fundamental, média e especial; instituições de ensino superior e técnico; cursos de qualificação; atenção básica, hospitais, especialidades e vigilância em saúde"
          helpText="Considere educação infantil, fundamental, média e especial; instituições de ensino superior e técnico; cursos de qualificação; atenção básica, hospitais, especialidades e vigilância em saúde"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="educacao_saude_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados, como escolas, matrículas, IDEB, evasão, instituições e cursos ofertados, unidades de saúde, cobertura da atenção básica, leitos e outros indicadores disponíveis, sempre com ano de referência"
          helpText="Escolas, matrículas, IDEB, evasão, instituições e cursos ofertados, unidades de saúde, cobertura da atenção básica, leitos e outros indicadores disponíveis, sempre com ano de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="educacao_saude_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados, considerando vagas, transporte escolar, infraestrutura, professores, acesso à qualificação, cobertura de saúde, atendimento hospitalar e especialidades"
          helpText="Considere vagas, transporte escolar, infraestrutura, professores, acesso à qualificação, cobertura de saúde, atendimento hospitalar e especialidades"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="educacao_saude_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas, considerando novas escolas, reformas, formação, inclusão digital, ampliação de cursos, unidades de saúde, equipes, leitos e especialidades"
          helpText="Considere novas escolas, reformas, formação, inclusão digital, ampliação de cursos, unidades de saúde, equipes, leitos e especialidades"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao4"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao4"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
